import React, {createContext, useEffect, useRef, useState} from 'react'
import {useLoginModalStore} from '@store/LoginModalStore'
import {shallow} from 'zustand/shallow'
import LoginModal from '@feature/common/components/LoginModal/LoginModal'
import AlertModal from '@component/modal/AlertModal'
import {useAlertModalStore} from '@store/AlertModalStore'
import PendingInvoiceModal from '@feature/common/components/PendingInvoiceModal/PendingInvoiceModal'
import {useLoginStore} from '@store/LoginStore'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import useQueryGetTodayDailyReport from '@hook/query/user/account/report/useQueryGetTodayDailyReport'
import useQueryGetPoint from '@hook/query/account/point/useQueryGetPoint'
import MemePhishingSiteModal from '@feature/meme/MemePhishingSiteModal/MemePhishingSiteModal'
import {useRouter} from 'next/router'
import FloatingMessage from '@feature/common/components/FloatingMessage/FloatingMessage'
import DailyReportModal from '@feature/common/components/DailyReportModal/DailyReportModal'

export const ModalContext = createContext({
    isShowDailyReport: false,
    setIsShowDailyReport: e => {},
})

const ModalContainer = () => {
    const [isShowDailyReport, setIsShowDailyReport] = useState(false)

    const router = useRouter()
    const {setRedirectUrl, setInitRoute} = useLoginModalStore(state => ({
        setRedirectUrl: state.setRedirectUrl,
        setInitRoute: state.setInitRoute,
    }))

    const id = useLoginStore(state => state.id)
    const {} = useQueryGetPoint(true)

    const {isVisibleLoginModal, hideLoginModal, code} = useLoginModalStore(
        state => ({
            isVisibleLoginModal: state.isVisibleLoginModal,
            hideLoginModal: state.hideLoginModal,
            code: state?.code,
        }),
        shallow,
    )

    const {alertModal, setAlertModal} = useAlertModalStore(
        state => ({
            alertModal: state.alertModal,
            setAlertModal: state.setAlertModal,
        }),
        shallow,
    )

    const loginModalRef = useRef(null)
    const AlertModalRef = useRef(null)

    const {data} = useQueryFetchMe(undefined, false)
    const {data: dailyReport} = useQueryGetTodayDailyReport()

    const pendingInvoiceModalRef = useRef<any>()
    const dailyReportModalRef = useRef<any>()

    useEffect(() => {
        if (isVisibleLoginModal) {
            loginModalRef?.current?.show()
        } else {
            loginModalRef?.current?.close()
        }
    }, [isVisibleLoginModal])

    useEffect(() => {
        if (alertModal) {
            AlertModalRef?.current?.show()
        } else {
            setAlertModal(undefined)
        }
    }, [alertModal, setAlertModal])

    useEffect(() => {
        localStorage.removeItem('isCheckInvoiceModal')
    }, [])
    useEffect(() => {
        const isCheckPendingInvoice = localStorage.getItem('isCheckInvoiceModal')

        if (!isCheckPendingInvoice && data?.pending_invoices > 0 && id === data?.id) {
            localStorage.setItem('isCheckInvoiceModal', 'true')
            setTimeout(() => {
                pendingInvoiceModalRef?.current?.show()
            }, 500)
        }
        if (isCheckPendingInvoice && !id) {
            localStorage.removeItem('isCheckInvoiceModal')
        }
    }, [id, data])

    useEffect(() => {
        if (
            dailyReport &&
            data?.preferences?.portfolio_msg_enabled !== false &&
            dailyReport?.created_at &&
            data?.id === dailyReport?.user_id
        ) {
            if (
                !localStorage.getItem(`todayDailyReport_${data?.id}`) ||
                localStorage.getItem(`todayDailyReport_${data?.id}`) !==
                    `${dailyReport?.user_id}_${dailyReport?.created_at}`
            ) {
                localStorage.setItem(
                    `todayDailyReport_${data?.id}`,
                    `${dailyReport?.user_id}_${dailyReport?.created_at}`,
                )
                dailyReportModalRef?.current?.show()
                setIsShowDailyReport(true)
            }
        }
    }, [dailyReport, data])

    return (
        <ModalContext.Provider value={{isShowDailyReport, setIsShowDailyReport}}>
            <LoginModal
                ref={loginModalRef}
                onClose={() => {
                    hideLoginModal()
                    setRedirectUrl(undefined)
                    setInitRoute(undefined)
                }}
                code={code}
            />
            <AlertModal ref={AlertModalRef} />
            <PendingInvoiceModal ref={pendingInvoiceModalRef} id={id} />
            <DailyReportModal ref={dailyReportModalRef} />

            <FloatingMessage />
        </ModalContext.Provider>
    )
}

export default ModalContainer
